import { EVENTS } from '../constants/webSocketConsts/events';
import { NotificationGroups } from '../store/notifications/types';
import {
  insertInvoiceNotifications,
  deleteNotifications,
  updateNotifications,
} from '../store/notifications/actions';

const newInvoiceNotificationHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
      return insertInvoiceNotifications(
        items,
        NotificationGroups.NewInvoiceNotifications,
      );
    case EVENTS.MODIFY:
      return updateNotifications(
        items,
        NotificationGroups.NewInvoiceNotifications,
      );
    case EVENTS.REMOVE:
      return deleteNotifications(
        items,
        NotificationGroups.NewInvoiceNotifications,
      );
    default:
      break;
  }
  return null;
};

export default newInvoiceNotificationHandler;
